import React from "react";
import './rrt-tag.css';

const RrtTag = ({...props}) => {
  const {label} = props;

  return<div className="rrt-tag">{label}</div>
}

export default RrtTag;